// import { Button, Divider, IconButton } from "@mui/material";
// import React from "react";
// import RemoveIcon from "@mui/icons-material/Remove";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import { CartItem } from "../../../types/cartTypes";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import {
//   deleteCartItem,
//   updateCartItem,
//   fetchUserCart,
// } from "../../../Redux Toolkit/Customer/CartSlice";
// import {
//   addProductToWishlist,
//   getWishlistByUserId,
// } from "../../../Redux Toolkit/Customer/WishlistSlice";

// interface CartItemProps {
//   item: CartItem;
//   showDivider?: boolean;
// }

// const CartItemCard: React.FC<CartItemProps> = ({ item, showDivider = true }) => {
//   const dispatch = useAppDispatch();

//   const handleUpdateQuantity = (value: number) => {
//     dispatch(
//       updateCartItem({
//         jwt: localStorage.getItem("jwt"),
//         cartItemId: item.id,
//         cartItem: { quantity: item.quantity + value },
//       })
//     ).then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));
//   };

//   const handleRemoveCartItem = () => {
//     return dispatch(
//       deleteCartItem({
//         jwt: localStorage.getItem("jwt") || "",
//         cartItemId: item.id,
//       })
//     ).then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));
//   };

//   const handleMoveToWishlist = () => {
//     if (!item.product?.id) return;

//     dispatch(addProductToWishlist({ productId: item.product.id }))
//       .then(() => dispatch(getWishlistByUserId()))
//       .then(() => handleRemoveCartItem());
//   };

//   return (
//     <div className="bg-white">
//       <div className="p-4 sm:p-5 grid grid-cols-[90px_1fr] sm:grid-cols-[110px_1fr_auto_auto] gap-4 items-center">
//         <div className="w-[90px] h-[90px] sm:w-[110px] sm:h-[110px] border rounded-md overflow-hidden bg-gray-50">
//           <img
//             className="w-full h-full object-cover"
//             src={item.product.images?.[0]}
//             alt={item.product.title}
//           />
//         </div>

//         <div className="space-y-1 min-w-0">
//           <h1 className="font-semibold text-sm sm:text-base line-clamp-2">
//             {item.product.title}
//           </h1>

//           <p className="text-gray-500 text-xs">
//             Sold by: {item.product.seller?.sellerName}
//           </p>

//           <p className="text-green-700 text-xs font-medium">In Stock</p>

//           <p className="text-gray-500 text-xs">
//             <strong>7 days return</strong> available
//           </p>
//         </div>

//         <div className="col-span-2 sm:col-span-1 flex sm:block justify-between items-center">
//           <p className="text-gray-700 font-semibold mb-0 sm:mb-3">
//             ₹{item.sellingPrice}
//           </p>

//           <div>
//             <p className="text-xs font-medium mb-1 hidden sm:block">Quantity</p>

//             <div className="flex items-center border rounded-md overflow-hidden">
//               <Button
//                 size="small"
//                 disabled={item.quantity === 1}
//                 onClick={() => handleUpdateQuantity(-1)}
//                 sx={{ minWidth: "36px" }}
//               >
//                 <RemoveIcon fontSize="small" />
//               </Button>

//               <span className="px-4 font-semibold text-sm">
//                 {item.quantity}
//               </span>

//               <Button
//                 size="small"
//                 onClick={() => handleUpdateQuantity(1)}
//                 sx={{ minWidth: "36px" }}
//               >
//                 <AddIcon fontSize="small" />
//               </Button>
//             </div>
//           </div>
//         </div>

//         <div className="col-span-2 sm:col-span-1 flex justify-end gap-3">
//           <IconButton size="small" onClick={handleMoveToWishlist}>
//             <FavoriteBorderIcon fontSize="small" />
//           </IconButton>

//           <IconButton onClick={handleRemoveCartItem} size="small">
//             <DeleteOutlineIcon fontSize="small" />
//           </IconButton>
//         </div>
//       </div>

//       {showDivider && <Divider />}
//     </div>
//   );
// };

// export default CartItemCard;



import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
} from "@mui/material";
import React, { useState } from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { CartItem } from "../../../types/cartTypes";
import { useAppDispatch } from "../../../Redux Toolkit/Store";
import {
    deleteCartItem,
    updateCartItem,
    fetchUserCart,
} from "../../../Redux Toolkit/Customer/CartSlice";
import {
    addProductToWishlist,
    getWishlistByUserId,
} from "../../../Redux Toolkit/Customer/WishlistSlice";

interface CartItemProps {
    item: CartItem;
    showDivider?: boolean;
}

const CartItemCard: React.FC<CartItemProps> = ({ item, showDivider = true }) => {
    const dispatch = useAppDispatch();
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const handleUpdateQuantity = (value: number) => {
        dispatch(
            updateCartItem({
                jwt: localStorage.getItem("jwt"),
                cartItemId: item.id,
                cartItem: { quantity: item.quantity + value },
            })
        ).then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));
    };

    const handleRemoveCartItem = () => {
        return dispatch(
            deleteCartItem({
                jwt: localStorage.getItem("jwt") || "",
                cartItemId: item.id,
            })
        ).then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));
    };

    const handleMoveToWishlist = () => {
        if (!item.product?.id) return;

        dispatch(addProductToWishlist({ productId: item.product.id }))
            .then(() => dispatch(getWishlistByUserId()))
            .then(() => handleRemoveCartItem())
            .then(() => setDeleteDialogOpen(false));
    };

    const handleDeleteOnly = () => {
        handleRemoveCartItem().then(() => setDeleteDialogOpen(false));
    };

    return (
        <div className="bg-white">
            <div className="p-4 sm:p-5 grid grid-cols-[90px_1fr] sm:grid-cols-[110px_1fr_190px_70px] gap-4 items-center">
                <div className="w-[90px] h-[90px] sm:w-[110px] sm:h-[110px] border rounded-md overflow-hidden bg-gray-50">
                    <img
                        className="w-full h-full object-cover"
                        src={item.product.images?.[0]}
                        alt={item.product.title}
                    />
                </div>

                <div className="space-y-1 min-w-0">
                    <h1 className="font-semibold text-sm sm:text-base line-clamp-2">
                        {item.product.title}
                    </h1>

                    {/* PRODUCT DETAILS */}
                    <div className="space-y-1 text-xs text-gray-600">
                        {item.product.color && (
                            <p>
                                <strong>Color:</strong> {item.product.color}
                            </p>
                        )}

                        {item.product.sizes && (
                            <p>
                                <strong>Size:</strong> {item.product.sizes}
                            </p>
                        )}

                        {item.product.description && (
                            <p className="line-clamp-1">
                                <strong>Description:</strong> {item.product.description}
                            </p>
                        )}
                    </div>

                    {/* <p className="text-gray-500 text-xs">
                        Sold by: {item.product.seller?.sellerName}
                    </p> */}

                    {/* <p className="text-green-700 text-xs font-medium">
                        In Stock
                    </p> */}

                    {/* <p className="text-gray-500 text-xs">
                        <strong>7 days return</strong> available
                    </p> */}
                </div>

                <div className="col-span-2 sm:col-span-1 flex items-center justify-between sm:justify-center gap-4">
                    <p className="text-gray-700 font-semibold text-lg sm:text-base min-w-[70px]">
                        ₹{item.sellingPrice}
                    </p>

                    <div>
                        <p className="text-xs font-medium mb-1 hidden sm:block">
                            Quantity
                        </p>

                        <div className="flex items-center border rounded-md overflow-hidden">
                            <Button
                                size="small"
                                disabled={item.quantity === 1}
                                onClick={() => handleUpdateQuantity(-1)}
                                sx={{ minWidth: "34px" }}
                            >
                                <RemoveIcon fontSize="small" />
                            </Button>

                            <span className="px-4 font-semibold text-sm">
                                {item.quantity}
                            </span>

                            <Button
                                size="small"
                                onClick={() => handleUpdateQuantity(1)}
                                sx={{ minWidth: "34px" }}
                            >
                                <AddIcon fontSize="small" />
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="col-span-2 sm:col-span-1 flex justify-end sm:justify-center gap-3">
                    <IconButton size="small" onClick={handleMoveToWishlist}>
                        <FavoriteBorderIcon fontSize="small" />
                    </IconButton>

                    <IconButton size="small" onClick={() => setDeleteDialogOpen(true)}>
                        <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                </div>
            </div>

            {showDivider && <Divider />}

            <Dialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Remove item from cart?</DialogTitle>

                <DialogContent>
                    <p className="text-sm text-gray-600">
                        You can also move this product to wishlist.
                    </p>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={handleMoveToWishlist}
                        className="whitespace-nowrap"
                        sx={{
                            px: 2,
                            fontSize: {
                                xs: "12px",
                                sm: "14px",
                            },
                        }}
                    >
                        Move to Wishlist
                    </Button>

                    <Button variant="contained" color="error" onClick={handleDeleteOnly}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CartItemCard;